export default "__VITE_ASSET__DREM$YuV__"